module.exports = __webpack_public_path__ + "static/support-site-og-image-81a9b3b79896f477a020f0e295b364e5.png";